module.exports = __webpack_public_path__ + "media/KikiB.25273ffd.mp3";